import { useState, useEffect } from 'react';
import utils from './utils';
import CONSTANTS from './constants';

const { DB_API_KEY_CACHE, DB_API_KEY_TTL_MINUTES } = CONSTANTS.CACHE_CONFIG;

function getCachedValue() {
    const cached = localStorage.getItem(DB_API_KEY_CACHE);
    if (!cached) return null;

    try {
        const parsed = JSON.parse(cached);
        if (parsed.expiry && Date.now() < parsed.expiry) {
            return parsed.value;
        }
    } catch {
        console.warn('❌ Failed to parse cached DB API key — clearing.');
    }

    localStorage.removeItem(DB_API_KEY_CACHE);
    return null;
}

function useDbApiKey(instance, account) {
    const [apiKey, setApiKey] = useState(() => getCachedValue());
    const [loading, setLoading] = useState(!apiKey);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (apiKey) return;

        const fetchApiKey = async () => {
            setLoading(true);
            try {
                const token = await utils.getAccessToken(instance, account, { scopes: ['User.Read'] });
                const fetchUrl = process.env.REACT_APP_GVMM_API_KEY_URL_V2;

                const res = await fetch(fetchUrl, {
                    headers: {
                        Authorization: `Bearer ${token.accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });

                const responseJson = await res.json();
                const { value } = responseJson;
                const expiry = Date.now() + DB_API_KEY_TTL_MINUTES * 60 * 1000;
                localStorage.setItem(DB_API_KEY_CACHE, JSON.stringify({ value, expiry }));
                setApiKey(value);

            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchApiKey();
    }, [apiKey, instance, account]);

    return { apiKey, loading, error };
}

export default useDbApiKey;
